import { getCounterSetOnSale } from './helpers';
import { NEW_OBJECTS_NAMES } from '../interfaces/village';
import { IVillageSchema, INewobjectCategorySetSchema } from '../types';

export const getMicrodata = (type = 'Offer', isJsonLd = false) =>
  isJsonLd
    ? {
        '@context': 'http://schema.org',
        '@type': type,
      }
    : {
        itemScope: true,
        itemType: `http://schema.org/${type}`,
      };

const filterInfinity = (value: number) => (Math.abs(value) === Infinity ? undefined : value);

export const getAggregateOfferMicrodata = (village: IVillageSchema) => {
  const { counterSet, description } = village;
  const { priceMax, priceMin } = getMaxMinObjectsPrice(village);

  return JSON.stringify({
    ...getMicrodata('AggregateOffer', true),
    description: description ? encodeURIComponent(description) : '',
    highPrice: filterInfinity(priceMax),
    lowPrice: filterInfinity(priceMin),
    offerCount: getCounterSetOnSale(counterSet ?? {}),
    priceCurrency: 'RUB',
  });
};

function getMaxMinObjectsPrice(village: IVillageSchema) {
  const { newobjectCategorySet } = village;

  const initial = { priceMax: Number(village.priceMax) || -Infinity, priceMin: Number(village.priceMin) || +Infinity };

  if (!newobjectCategorySet) {
    return initial;
  }

  return Object.keys(NEW_OBJECTS_NAMES).reduce((acc, val) => {
    const object = newobjectCategorySet[val as keyof INewobjectCategorySetSchema];

    if (!object) {
      return acc;
    }
    const [priceMax, priceMin] = [Number(object.priceMax), Number(object.priceMin)];

    return {
      priceMax: acc.priceMax < priceMax ? priceMax : acc.priceMax,
      priceMin: acc.priceMin > priceMin ? priceMin : acc.priceMin,
    };
  }, initial);
}

const getJsonLd = (data: string) => `<script type="application/ld+json">${data}</script>`;

export const getLdJsonMicrodata = (village: IVillageSchema) => {
  const ldJsonMicrodata = [getAggregateOfferMicrodata(village)];

  return ldJsonMicrodata.map(getJsonLd).join('');
};
